import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/products/{creatorSlug}/{productSlug}']['PUT'];
type Input =
  & THIS_API['params']
  & {
    updates: THIS_API['body'];
  };

const updateProduct = async ({ creatorSlug, productSlug, updates }: Input): Promise<void> => {
  await noodleApiClient.put(`/products/${creatorSlug}/${productSlug}`, updates);
};

export default updateProduct;
